import { format, parseISO } from 'date-fns'

const Note = ({
  id,
  note,
  createdAt,
}) => {
  const noteDate = format(parseISO(createdAt), 'EE, LLL d, yyyy - HH:MM')

  return (
    <div key={id} className="note mb-3">
      {note}
      <div className="note-date">{noteDate}</div>
    </div>
  );
}

export default Note
